import React, { useState, useEffect } from 'react';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';

import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IsNullOrEmpty } from "../../../services/CustomService";
import { ProgressSpinner } from 'primereact/progressspinner';
import {
    Form,
    Await,
    defer,
    useLoaderData,
} from "react-router-dom";
import { getTools } from "../../../data/loca/tools";
import { getAccount } from "../../../data/accounts";
export async function loader({ params }) {
   
    const tools = getTools();
    const account = getAccount();
    return defer({
        tools: tools,
        account: account
    });
}
export default function ToolsList() {
   
    const  data  = useLoaderData();

    const [filters, setFilters] = useState(null);
    const [loading] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');


   
    useEffect(() => {
      
        initFilters();
    }, []);



    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue('');
    };

 
    const renderHeader = () => {
        return (
            <div className="tools-list-toolbar">
                <span className="p-input-icon-left tools-list-search">
                    <i className="pi pi-search" />
                    <InputText id="searchTools" value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Rechercher un outil..." />
                </span>

                <Form className="tools-list-add-button" method="get" action="/outils/ajout" >
                    <Button icon="pi pi-plus" type="submit" size="small">Ajouter un outil</Button>
                </Form>
            </div>

        );
    };

    const nameBodyTemplate = (rowData) => {

        return (
            <div className="tools-list-name-cell">

                {(!IsNullOrEmpty(rowData.base64Picture)) ? (
                    <img className="tools-list-thumb" key={rowData.publicId} alt={rowData.name} src={rowData.base64Picture || null} />

                ) : (
                        <div className="tools-list-thumb tools-list-thumb-empty"></div>
                )}
                <span>
                    <b>{rowData.name}</b>
                    <small>{[rowData.brand, rowData.model].filter(Boolean).join(" · ") || "Informations matériel"}</small>
                </span>
            </div>
        );
    };

    const priceBodyTemplate = (rowData) => {
        return <span className="tools-list-price">{rowData.priceDayCents / 100 + "\u20ac"}</span>;
    };
 


    const selectedTool = (rowData) => {
        let link = `/monoutil/${rowData.publicId}`
        //redirect to link
        //go
        window.location.href = link;
        
    };
    
    const servicesBodyTemplate = (rowData) => {
        return (
            <div className="tools-list-service-cell" >
            <div className={"kiwiizPicto connectedService " + (!rowData.kiwiizLink ? 'connectedServiceUnavailable' : '')}>
            </div>
        </div>);
    };
    
    const header = renderHeader();
    return (
        <div className="tools-list-page">
            <div className="tools-list-page-header">
                <div className="tools-list-page-title">
                    <i className="pi pi-wrench"></i>
                    <div>
                        <p className="tools-list-kicker">Catalogue</p>
                        <h1>Liste des outils</h1>
                        <p>Retrouvez, filtrez et administrez le matériel disponible à la location.</p>
                    </div>
                </div>
                {/* Await doit être sous un Suspense : sans lui, une navigation
                    côté client (mise à jour synchrone) déclenche l'erreur React #426. */}
                <React.Suspense fallback={null}>
                    <Await resolve={data.account} errorElement={null}>
                        {(account) => (
                            <a className="tools-list-public-link" href={account.baseUrl + "/mesoutils/" + account.publicLink}>
                                <i className="pi pi-external-link"></i>
                                <span>Mon lien public</span>
                            </a>
                        )}
                    </Await>
                </React.Suspense>
            </div>


            <React.Suspense
                fallback={
                    <div className="card flex justify-content-center">
                    <ProgressSpinner />
                </div>}
            >
                <Await
                    resolve={data.tools}
                    errorElement={
                        <p>Erreur lors du chargement des outils !</p>
                    }
                >
                    
                    {(tools) => (
                        <div className="tools-list-card">
                            <DataTable className="tools-list-table" selectionMode="single" onSelectionChange={(e) => selectedTool(e.value)} value={tools} paginator rows={20} loading={loading} dataKey="id" filters={filters} globalFilterFields={['name', 'brand', 'model', 'priceDayCents', 'keywords']} header={header} emptyMessage="Aucun outil trouv&eacute;">
                                <Column header="Nom" body={nameBodyTemplate} />
                                <Column field="brand" header="Marque" headerClassName="tools-list-mobile-hidden" className="tools-list-mobile-hidden" />
                                <Column field="model" header="Mod&egrave;le" headerClassName="tools-list-mobile-hidden" className="tools-list-mobile-hidden" />
                                <Column header="Prix/j" dataType="numeric" body={priceBodyTemplate} />
                                <Column header="Services" body={servicesBodyTemplate} headerClassName="tools-list-mobile-hidden" className="tools-list-mobile-hidden" />
                            </DataTable>
                            
                           
                        </div>
                    )}
                </Await>
            </React.Suspense>

            
        </div>
    );
}
